import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoursesSection } from '../../shared/courses/components/courses-section/courses-section';

@Component({
  selector: 'app-courses',
  imports: [CoursesSection],
  template: `
    <section class="pt-32">
      <app-courses-section />
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Courses {}
